<template>
  <div class="relative inline-block font-medium">
    <h1 class="type-font-salt-ss02 text-charcoal -rotate-10 text-center">
      error!
    </h1>
    <div class="pointer-events-none absolute inset-0">
      <PayloadIcon
        class="text-yellow absolute bottom-[0.65em] left-[-0.25em] h-[0.33em] -rotate-20"
        icon="SvgIconShockA"
      />
      <PayloadIcon
        class="text-green absolute bottom-[1.1em] left-[1.4em] h-[0.35em]"
        icon="SvgIconFrustrationA"
      />
      <PayloadIcon
        class="text-pink-dark absolute bottom-[0.2em] left-[2.6em] h-[0.4em] rotate-20"
        icon="SvgIconPoo"
      />

      <PayloadIcon
        class="text-blue-dark absolute bottom-[-0.1em] left-[1.6em] h-[0.35em] rotate-170"
        icon="SvgIconLike"
      />
    </div>
  </div>
</template>
